export default __webpack_public_path__ + "static/media/quiz1.da26385d.png";